import AccountView from "../components/account/AccountView";
import SettingView from "../components/setting/SettingView";
import SuccessPage from "../components/Success Payment/SuccessPage";


export const PrivateRoutes = [
    { url: '/account', component: <AccountView /> },
    { url: '/success', component: <SuccessPage /> },
    { url: '/setting', component: <SettingView /> },
]